import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'tolifecloud-ui';

  constructor(public updates:SwUpdate) {
    this.updateClient();
  }
  
  updateClient() {
    if (!this.updates.isEnabled) {
      console.log('Not Enabled');
      return;
    }
    // API nova do SwUpdate (Angular 16+): 'available'/'activated' foram removidos em favor de 'versionUpdates'
    this.updates.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe((event) => {
        console.log(`current`, event.currentVersion, `available `, event.latestVersion);
        this.updates.activateUpdate().then(() => location.reload());
      });
  }
}
